import { Grid } from '@material-ui/core';

// locals
import { useInputChangeHandler } from 'app/hooks';
import { FormInput, MaskedInput } from '../../atoms';

const FilterPharmacyUsers = ({ handleChange }) => {
  const { handleDebouncedValue, preventNonSpecialDebounceInput, handlePhoneInput } =
    useInputChangeHandler(handleChange);

  return (
    <>
      <Grid container spacing={3} className="items-center mt-8">
        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <FormInput
            id="customer_name"
            name="full_name"
            label="Ad Soyad"
            placeholder="Ad Soyad"
            onChange={preventNonSpecialDebounceInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={3} xl={3}>
          <MaskedInput
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            alwaysShowMask
            id="id_telephone"
            name="telephone"
            placeholder="Cep Telefonu"
            label="Cep Telefonu"
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={5} xl={3}>
          <FormInput
            id="customer_email"
            name="email"
            placeholder="E-Posta Adresi"
            label="E-Posta Adresi"
            onChange={handleDebouncedValue}
            maxLength={50}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FilterPharmacyUsers;
